import { Injectable } from '@angular/core';
import loadImage from 'blueimp-load-image';
import { Observable, Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor() { }

  parseMetaData(file: File): Observable<any> {
    // return new Promise((resolve) => {
    //   loadImage.parseMetaData(file, (data: any) => {
    //     resolve(data);
    //   });
    // });
    return new Observable((observer: Observer<any>) => {
      loadImage.parseMetaData(file, (data: any) => {
        observer.next(data);
        observer.complete();
      });
    });
  }

  getDataUri(blobImage: Blob, options: any): Observable<string> {
    // return new Promise(resolve => {
    //   loadImage(blobImage, (canvas: HTMLCanvasElement) => {
    //     resolve(canvas.toDataURL(blobImage.type));
    //   }, options);
    // });
    return new Observable((observer: Observer<any>) => {
      loadImage(blobImage, (canvas: HTMLCanvasElement) => {
        observer.next(canvas.toDataURL(blobImage.type));
        observer.complete();
      }, options);
    });
  }

  getBlob(blobImage: Blob, options: any): Observable<Blob> {
    // return new Promise(resolve => {
    //   loadImage(blobImage, (canvas: HTMLCanvasElement) => {
    //     canvas.toBlob(
    //       (blob: Blob | null) => {
    //         resolve(blob);
    //       },
    //       'image/jpeg',
    //       0.95
    //     );
    //   }, options);
    // });
    return new Observable((observer: Observer<any>) => {
      loadImage(blobImage, (canvas: HTMLCanvasElement) => {
        canvas.toBlob(
          (blob: Blob | null) => {
            observer.next(blob);
            observer.complete();
          },
          'image/jpeg',
          0.95
        );
      }, options);
    });
  }
}
